/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import client from '@/shared/api/axios-client'
import type {
  DeleteWithdrawalSecretsMutationRequest,
  DeleteWithdrawalSecretsMutationResponse,
  DeleteWithdrawalSecrets400,
  DeleteWithdrawalSecrets403,
} from '../entities/DeleteWithdrawalSecrets'
import type { RequestConfig, ResponseErrorConfig } from '@/shared/api/axios-client'
import type { UseMutationOptions, QueryClient } from '@tanstack/react-query'
import { deleteWithdrawalSecrets } from '../api/deleteWithdrawalSecrets'
import { useMutation } from '@tanstack/react-query'

export const deleteWithdrawalSecretsMutationKey = () => [{ url: '/withdrawal-secrets' }] as const

export type DeleteWithdrawalSecretsMutationKey = ReturnType<typeof deleteWithdrawalSecretsMutationKey>

/**
 * @description Удаление api-ключа вывода средств для таксопарка
 * @summary Удаление api-ключа вывода средств для таксопарка
 * {@link /withdrawal-secrets}
 */
export function useDeleteWithdrawalSecrets<TContext>(
  options: {
    mutation?: UseMutationOptions<
      DeleteWithdrawalSecretsMutationResponse,
      ResponseErrorConfig<DeleteWithdrawalSecrets400 | DeleteWithdrawalSecrets403>,
      { data: DeleteWithdrawalSecretsMutationRequest },
      TContext
    > & { client?: QueryClient }
    client?: Partial<RequestConfig<DeleteWithdrawalSecretsMutationRequest>> & { client?: typeof client }
  } = {},
) {
  const { mutation: { client: queryClient, ...mutationOptions } = {}, client: config = {} } = options ?? {}
  const mutationKey = mutationOptions?.mutationKey ?? deleteWithdrawalSecretsMutationKey()

  return useMutation<
    DeleteWithdrawalSecretsMutationResponse,
    ResponseErrorConfig<DeleteWithdrawalSecrets400 | DeleteWithdrawalSecrets403>,
    { data: DeleteWithdrawalSecretsMutationRequest },
    TContext
  >(
    {
      mutationFn: async ({ data }) => {
        return deleteWithdrawalSecrets(data, config)
      },
      mutationKey,
      ...mutationOptions,
    },
    queryClient,
  )
}